import styled from 'styled-components';
import { getColor, Theme } from 'styles/theme';
import CustomLink, { CustomLinkProps } from 'components/Globals/Base/Link';
import { NextCustomImage } from 'components/Image';
import { ImageProps } from 'next/image';
import { breakpoint, font } from 'styles/globals';
import { primaryLink } from 'components/Globals/Base/Link/LinkStyles';
import { getIcon } from 'styles/icons';

export const Image = styled(NextCustomImage)<ImageProps>`
  border-radius: 50%;
  width: 40px !important;
  height: 40px !important;
`;

export const Name = styled.span<{ theme: Theme }>`
  color: ${getColor('textPrimary')};
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  ${primaryLink};
`;

export const Role = styled.span<{ theme: Theme }>`
  color: ${getColor('textSecondary')};
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.5px;
`;

export const CloseButton = styled.button<{ theme: Theme }>`
  align-self: flex-start;
  width: 24px;
  height: 24px;

  ${getIcon('svg-states')};

  &::before {
    ${getIcon('close-icon', { height: 16, width: 15 })};
    background-color: ${getColor('neutralBlack')};
    margin: auto;
  }
`;

export const FactValue = styled.span<{ theme: Theme }>`
  background-color: ${getColor('shadeBrandPrimary100')};
  padding: 4px 8px 4px 8px;
`;

export const Bio = styled.span<{ theme: Theme }>`
  margin-bottom: 16px;
  color: ${getColor('textPrimary')};
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.5px;
  
  p a {
    display: inline;
    color: ${getColor('textLink')};
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const BioLink = styled(CustomLink)<CustomLinkProps>``;

export const Header = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const FactContainer = styled.div<{ theme: Theme }>`
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
  align-items: center;
  
  span {
    color: ${getColor('textAccentPrimary')};
    font-family: ${font.graphikCond};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: 0.5px;
  }
`;

export const Footer = styled.div`
  display: flex;
  
  ${BioLink} {
    margin-left: auto;
  }
`;

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  border-top: 4px solid ${getColor('textAccentPrimary')};
  box-shadow: 2px 2px 4px 0 ${getColor('surfaceBlack')}26;
  padding: 8px;
  width: 320px;
  background: ${getColor('surfaceWhite')};
  text-transform: none !important;
  
  @media (${breakpoint.mdMin}) {
    width: 376px;
  }
  
  @media (${breakpoint.lgMin}) {
    width: 510px;
  }

  &.author-bio {
    width: 100%;
    box-shadow: none;
    border-top: 1px solid ${getColor('borderSecondary')};
    padding: 16px; 

    &:first-of-type {
      border-top: none;
    }

    li {
      margin: 0;
      display: flex;
      align-items: center;
  
      a {
        display: flex;
        align-items: center;
      }
    }

    ${Footer} {
      margin: 16px 0;
    }
  
    ${Header} {
      margin-bottom: 16px;
    }
  
    ${Bio} {
      margin: 16px 0;

      p {
        margin: 0;
      }
    }

    ${FactContainer} {
      margin: 0;
    }
  }
`;
